import { VERIFY_EMAIL } from "../configs/routes";
import api from "./api";

export const verifyEmailAPI = ({token,password}) =>
    new Promise((resolve, reject) => {
        api
            .post(VERIFY_EMAIL, {token,password})
            .then((response) => resolve(response.data))
            .catch((err) => reject(err?.response?.data?.message || err.message || "Something went wrong"));

    });
